import { border } from '@topconagriculture/theme';
export const makeSelectTheme = (theme) => ({
    control: (base) => ({
        ...base,
        borderStyle: 'none',
        borderWidth: 0,
        borderColor: 'transparent',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        minHeight: 27,
        padding: [0, theme.space.padding.smallest],
        cursor: 'text',
    }),
    valueContainer: (base) => ({
        ...base,
        color: 'currentColor',
        padding: 0,
    }),
    clearIndicator: (base) => ({
        ...base,
        cursor: 'pointer',
        padding: 0,
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        color: theme.color.font.dark,
        padding: [1, 0],
        cursor: 'pointer',
        opacity: state.disabled ? 0 : 1,
    }),
    indicatorSeparator: (base) => ({
        ...base,
        background: 'transparent',
    }),
    placeholder: (base) => ({
        ...base,
        color: 'currentColor',
        margin: 0,
        opacity: '0.5',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
    }),
    menu: (base) => ({
        ...base,
        marginTop: base.marginTop - 5,
        zIndex: 150,
        top: 'auto',
    }),
    menuList: (base) => ({
        ...base,
        paddingTop: 7,
        paddingBottom: 7,
    }),
    option: (base, state) => ({
        ...base,
        display: 'flex',
        alignItems: 'center',
        height: 47,
        padding: 0,
        paddingLeft: theme.space.padding.small,
        cursor: 'pointer',
        background: `${state.isFocused ? theme.color.grey.lightest : theme.color.background.light} !important`,
        color: theme.color.font.dark,
        '&:hover': {
            fontWeight: theme.font.weight.bold,
        },
        '&:first-child': {
            borderTop: 0,
        },
        borderTop: border(theme.color.grey.light),
    }),
});
//# sourceMappingURL=AutocompleteMultiSelectTheme.js.map